<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="'日報編集'" />
		<CommonFlame :title="template.name">
			<v-sheet class="pa-2" elevation="0">
				<v-form ref="form" v-model="valid">
					<DailyReportForm ref="reportForm" :template="template" :dailyReport.sync="daily_report" />
					<v-row no-gutters justify="center">
						<v-btn @click="submitForm" :disabled="!valid" color="secondary">
							<v-icon class="mr-2">mdi-pencil</v-icon>
							編集する</v-btn
						>
					</v-row>
				</v-form>
			</v-sheet>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import _ from "lodash"

import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import DailyReportForm from "./components/DailyReportForm.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		DailyReportForm,
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			template_id: this.$route.params.template_id,
			id: this.$route.params.id,
			template: {
				name: "",
				meta_keys: [],
			},
			department: {
				id: null,
				name: null,
			},
			daily_report: {
				title: null,
				place: null,
				memo: null,
				report_date: null,
				start_at: null,
				end_at: null,
				matter_id: null,
				files: [],
				existing_files: [],
				daily_report_meta_values_attributes: [],
			},
			valid: false,
		}
	},
	mounted() {
		authenticate.authenticateUser()
		const headers = authenticate.setHeader()
		const url = `/erp/v1/daily_report_templates/${this.template_id}/daily_reports/${this.id}/edit`
		axios
			.get(url, { headers })
			.then((res) => {
				this.template = res.data.template
				this.department = res.data.department
				this.daily_report = this.setDailyReport(res.data.daily_report)
				const existingMetaKeyIds = res.data.daily_report.daily_report_meta_values.map(
					(v) => v.daily_report_meta_key_id
				)
				const newMetaKeys = this.template.meta_keys.filter(
					(v) => !existingMetaKeyIds.includes(v.id)
				)
				newMetaKeys.forEach((m) => {
					let meta_value = { daily_report_meta_key_id: m.id }
					if (m.meta_type == "association") {
						meta_value.target_id = null
						meta_value.target_type = null
					} else {
						meta_value[`value_${m.meta_type}`] = null
					}
					this.daily_report.daily_report_meta_values_attributes.push(meta_value)
				})
			})
			.catch((err) => {
				errorHandling.errorResponse(err)
			})
	},
	methods: {
		submitForm() {
			if (!this.$refs.form.validate()) return
			let daily_report = Object.assign({}, this.daily_report)
			delete daily_report.files
			delete daily_report.existing_files
			const headers = authenticate.setHeader()
			const url = `/erp/v1/daily_report_templates/${this.template_id}/daily_reports/${this.id}`
			axios
				.put(url, { daily_report }, { headers })
				.then((response) => {
					const id = response.data
					if (!this.daily_report.files.length) return this.successUpload()
					this.uploadFiles(id, 0)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		uploadFiles(id, i) {
			let headers = authenticate.setHeader()
			headers["Content-type"] = "multipart/form-data"
			let formData = new FormData()
			formData.append("daily_report[file]", this.daily_report.files[i])
			axios
				.post(`/erp/v1/daily_reports/${id}/daily_report_files`, formData, { headers })
				.then((res) => {
					this.daily_report.files[i]
					if (this.daily_report.files.length == i + 1) return this.successUpload()
					this.uploadFiles(id, i + 1)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					this.$router.push({
						name: "daily_report_edit",
						params: { template_id: this.template_id, id },
					})
				})
		},
		successUpload() {
			this.$router.push({
				name: "daily_report_index",
				params: { department_id: this.department.id },
			})
			this.$store.dispatch("setFlash", {
				type: "notice",
				text: "日報を編集しました。",
			})
		},
		setDailyReport(dailyReport) {
			let newDailyReport = _.cloneDeep(dailyReport)
			newDailyReport.daily_report_meta_values_attributes = dailyReport.daily_report_meta_values.map(
				(v) => {
					if (v.value_time) {
						v.value_time = moment(v.value_time).format("HH:mm")
					}
					return v
				}
			)
			newDailyReport.start_at = dailyReport.start_at
				? moment(dailyReport.start_at).format("HH:mm")
				: null
			newDailyReport.end_at = dailyReport.end_at ? moment(dailyReport.end_at).format("HH:mm") : null
			delete newDailyReport.daily_report_meta_values
			newDailyReport.files = []
			return newDailyReport
		},
	},
}
</script>
